<template>
	<transition name="fade" duration="2000">
		<div class="loader" v-if="active">
			<span class="loader__text">Loading</span>
			<span class="loader__spinner"></span>
		</div>
	</transition>
</template>

<script>
export default {
    name: "loader",
    props: {
        active: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style lang="scss" type="text/scss">
// Styles and markup ripped from http://tobiasahlin.com/spinkit/

.loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: white;
    background-image: url("../assets/images/rn-head-fs8.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
    transition: opacity 1s linear;
    opacity: 1;

    &.fade-enter,
    &.fade-leave-to {
        opacity: 0;
    }

    &.fade-enter-to {
        opacity: 1;
    }

	&__text {
		text-transform: uppercase;
		position: absolute;
		top: calc(50% + 100px);
		left: calc(50% - 58px);
		font-family: 'Avenir-Black';
	}

	&__spinner {
		background-image: url('../assets/images/ic-spinner.png');
		background-size: cover;
		width: 30px;
		height: 30px;
		position: absolute;
		top: calc(50% + 93px);
		left: calc(50% + 30px);
		animation: spin 1s linear infinite;
	}
}

@-webkit-keyframes spin {
    0% {
        transform: rotate3d(0, 0, 1, 0deg);
    }
    100% {
        transform: rotate3d(0, 0, 1, 360deg);
    }
}
@keyframes spin {
    0% {
        transform: rotate3d(0, 0, 1, 0deg);
    }
    100% {
        transform: rotate3d(0, 0, 1, 360deg);
    }
}
</style>


// WEBPACK FOOTER //
// Loader.vue?6fa0edc0